'use strict';

class BaseService {
  /* @ngInject */
  constructor(Model, SegaUser) {
    Object.assign(this, {
      Model,
      SegaUser
    });
  }

  findById(id, filter) {
    return this.Model.findById({
      id: id,
      filter: filter
    }).$promise;
  }

  findOne(opts = {}) {
    return this.Model.findOne(opts).$promise;
  }

  find(opts = {}) {
    if (!opts.filter) {
      opts = Object.assign({}, { filter: opts });
    }
    if (!('order' in opts.filter)) {
      opts.filter.order = this.defaultOrder || 'name ASC';
    }
    return this.Model.find(opts).$promise;
  }

  getModels(opts = {}) {
    return this.getQueryOpts(opts).then(queryOpts => {
      return this.Model.find({
        filter: queryOpts
      }).$promise;
    });
  }

  getCount(opts = {}) {
    return this.getQueryOpts(opts).then(queryOpts => {
      // Hacky count opts so that deleted are included
      queryOpts.where.deleted = true;
      return this.Model.count(queryOpts).$promise;
    });
  }

  getQueryOpts(options) {
    let queryOpts = {};
    if (options.page && options.limit) {
      queryOpts.limit = options.limit;
      queryOpts.skip = (options.page - 1) * options.limit;
    }

    let where = options.where,
      include = options.include,
      order = options.order,
      deleted = options.deleted;
    Object.assign(queryOpts, { where, include, order, deleted });

    return this._getCurrentUser().then(user => {
      // FIXME: poor way of auto constraining by current logged in user
      const userConstraint =
        user && !user.isAdmin && this.Model.employee && !options.getAll;
      if (userConstraint) {
        if (!queryOpts.where) {
          queryOpts.where = {};
        }
        queryOpts.where.employeeId = user.employeeId;
      }
      return queryOpts;
    });
  }

  create(opts) {
    return new this.Model(opts);
  }

  save(instance) {
    if (instance.$save) {
      return instance.$save();
    } else {
      return this.Model.upsert(instance).$promise;
    }
  }

  destroyById(id) {
    return this.Model.destroyById({
      id: id
    }).$promise;
  }

  _getCurrentUser() {
    if (!this.SegaUser) {
      return Promise.resolve();
    }
    return this.SegaUser.getCurrent().$promise.then(user => {
      let isAdmin = !!user.roles.find(r => {
        return r.name === 'admin';
      });
      user.isAdmin = isAdmin;
      return user;
    });
  }
}

export default BaseService;
